import { StandaloneHttp404, StandaloneHttp404Props } from '@/components/post-type/404';
import { LabradorComponent, StandaloneComponent } from '@/types/component';

export const SvenskdamStandaloneHttp404: StandaloneComponent<StandaloneHttp404Props> = ({ ...props }) => {
  return <StandaloneHttp404 title="Sidan saknas (404) | Svenskdam" {...props} />;
};

export const standalone = SvenskdamStandaloneHttp404;

const SvenskdamLabradorHttp404: LabradorComponent = () => <SvenskdamStandaloneHttp404 />;

export default SvenskdamLabradorHttp404;
